import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/lo',
  },
  {
    path: '/lo/:id?/:content?',
    name: 'LearningObject',
    // route level code-splitting
    // this generates a separate chunk (model.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "lo" */ '@/views/LearningObject.vue'),
  },
  {
    path: '/sim/:id?',
    name: 'Simulator',
    component: () => import(/* webpackChunkName: "sim" */ '@/views/Simulator.vue'),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
